<!-- Card -->
<!-- Header -->
<div class="card-header">
  <h3 class="card-title">
    {{ 'general.general' | translate }}
  </h3>
</div>
<!-- End Header -->

<!-- Body -->
<div class="card-body">
  <div class="mb-3">
    <label class="form-label"> {{ 'general.status' | translate }} </label>

    <span *ngIf="sale$ | async as sale" class="text-dark ms-2">
      <span
        data-test-id="sale-status"
        [ngClass]="{
          'bg-soft-success': sale.statusCode === saleStatusCode.DONE,
          'bg-soft-primary': sale.statusCode === saleStatusCode.INFLIGHT,
          'bg-soft-secondary': sale.statusCode === saleStatusCode.CANCELLED,
          'bg-soft-info': sale.statusCode === saleStatusCode.PENDING_REQUIRED
        }"
        class="badge"
      >
        {{ 'saleModule.statusCode' + sale.statusCode | translate }}
        <span *ngIf="sale.isCreditOfSaleId">
          - {{ 'saleModule.isCreditSale' | translate }}
        </span>
      </span>
    </span>
  </div>

  <sale-form
    [readonly]="readonly"
    (onSubmit)="onSubmit($event)"
    [sale]="sale$ | async"
    [showSubmitButton]="!readonly"
  >
  </sale-form>
  <div *ngIf="(creditSales$ | async)?.length">
    <h4 *ngIf="sale$ | async as sale">
      {{
        (sale.total >= 0 ? 'saleModule.creditSales' : 'saleModule.relatedSale')
          | translate
      }}
    </h4>

    <div class="card-table">
      <dms-table
        [tableData]="creditSales$ | async"
        [tableType]="'creditedSales'"
        [readonly]="readonly"
        [showTotal]="false"
      >
      </dms-table>
    </div>
  </div>
</div>
<!-- End Body -->
<!-- End Card -->
